<template>
  <div class="announcement-warp">
    <adv-item adv-postion-name="column_notice_top_0" />
    <Listbox props-titile="活动公告">
      <module-title title="活动公告列表" class="module-title" type-title="inside" />
      <TabList :props-data="data" />
    </Listbox>
    <adv-item adv-postion-name="column_notice_bottom_0" />
  </div>
</template>
<script>
import Listbox from '@/views/common/listbox';
import TabList from '@/views/news/tabList';
export default {
  name: 'Announcement',
  components: {
    Listbox,
    TabList
  },
  data: () => {
    return {
      data: {
        interface: {
          list: 'geteduNoticeContentsList'
        },
        source: 'announcement'
      }
    };
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.announcement-warp{
    background-color: #f0f2f5;
    margin-top: 20px;
  .resoure{
    .box-card{
      margin: 10px 0;
    }
  }
  .breadcrumb{
    padding: 20px 0;
  }
  .announcement-item{
    border-bottom: #f3f3f3 solid 1px;
    padding: 12px 0;
  }
  .message-main{
      .title{
        font-size: 16px;
      }
      .text{
        margin-top: 10px;
        line-height: 22px;
        width: 100%;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
      }
    }
}

</style>
